import axios from 'axios'
import { KEY_SET_ACCEPTS_MARKETING } from '../customers/account/activate-account'
const ID_PAGE = 'js-page'

document.addEventListener('DOMContentLoaded', async () => {
  const elementPage = document.getElementById(ID_PAGE)
  if (!elementPage) return
  const acceptsMarketing =
    sessionStorage.getItem(KEY_SET_ACCEPTS_MARKETING) === 'true'
  if (!acceptsMarketing) return
  const { baseUrl, customerId, hashedCustomerId } = elementPage.dataset
  try {
    await axios.post(`${baseUrl}/customers/update_customer`, {
      id: customerId,
      h: hashedCustomerId,
      acceptsMarketing: true,
    })
    sessionStorage.removeItem(KEY_SET_ACCEPTS_MARKETING)
  } catch (error) {
    console.error(error)
  }
})
